import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'sr' | 'en' | 'ru';
function detectLanguage(): Language {
  const saved = localStorage.getItem('dtech-lang') as Language | null;
  if (saved === 'sr' || saved === 'en' || saved === 'ru') return saved;
  return 'sr';
}
export const translations = {
  sr: {
    nav: {
      home: 'Početna',
      products: 'Proizvodi',
      applications: 'Primene',
      servis: 'Servis',
      gallery: 'Galerija',
      faq: 'Pitanja',
      about: 'O nama',
      contact: 'Kontakt',
      requestQuote: 'Zatražite ponudu'
    },
    hero: {
      title: 'Električni sistemi za',
      titleHighlight: 'transport tereta',
      btnProducts: 'Pogledajte proizvode',
      btnQuote: 'Pošalji upit',
      capacity: 'Kapacitet',
      battery: 'Baterija',
      runtime: 'Rada',
      delivery: 'Dostupnost',
      deliveryValue: 'Na upit',
      runtimeValue: 'Do 4 sata'
    },
    what: {
      title: 'Šta je',
      titleHighlight: 'D-TECH SCA?',
      card1Title: 'Električna mašina',
      card1Text: 'Za kontrolisan transport tereta uz stepenice bez fizičkog napora i bez dodatne radne snage.',
      card2Title: 'Kapacitet do 250 kg',
      card2Text: 'Stabilan rad na nagibu, precizna kontrola i sigurnost pri svakom koraku.',
      card3Title: 'Profesionalno rešenje',
      card3Text: 'Namenjeno građevini, logistici, dostavi i svim objektima bez lifta.',
      footer: 'D-TECH SCA je kompaktan električni sistem za transport tereta uz stepenice. Projektovan za svakodnevni rad u realnim uslovima, pouzdan, stabilan i jednostavan za rukovanje.'
    },
    showcase: {
      title: '',
      titleHighlight: 'Konfiguracije',
      subtitle: '',
      requestQuote: 'Zatražite ponudu',
      price: 'bez PDV.',
      leadTime: 'Dostupnost na upit.',
      safetyTitle: 'Sigurnost na prvom mestu',
      safetyText: 'Električna kočnica za stabilan rad',
      capacity: 'Kapacitet',
      motor: 'Motor',
      battery: 'Baterija',
      weight: 'Težina',
      batteryNote: '* Rad baterije do 4h po setu pod opterećenjem u optimalnim uslovima. Dodatna baterija: €250 bez PDV.'
    },
    coreValues: {
      title: 'Zašto',
      titleHighlight: 'D-TECH?',
      subtitle: 'Svaki detalj je osmišljen za profesionalnu upotrebu.'
    },
    whyDtech: {
      title: 'Prednosti',
      titleHighlight: 'D-TECH sistema'
    },
    applications: {
      title: 'Gde se',
      titleHighlight: 'koristi?',
      subtitle: 'D-TECH oprema se primenjuje u različitim industrijama i situacijama.'
    },
    demo: {
      title: 'Zatražite',
      titleHighlight: 'demonstraciju',
      subtitle: 'Vidite mašinu na delu. Organizujemo demonstraciju na vašoj lokaciji.',
      btn: 'Zatražite demonstraciju'
    },
    contact: {
      title: 'Kontaktirajte',
      titleHighlight: 'nas',
      subtitle: 'Dostupni smo za sva pitanja i upite.'
    },
    popup: {
      badge: 'LETNJA AKCIJA 2026',
      title: 'Akcijske cene za sve modele',
      titleLine2: '',
      body: 'Cene svih D-TECH modela snižene su za do 200 €.',
      date: '15. avgusta 2026.',
      bonus: '',
      avans: 'Ponuda važi do 15. avgusta 2026.',
      limited: '',
      btnPrimary: 'Pogledajte modele',
      btnSecondary: ''
    },
    footer: {
      description: 'Profesionalna električna oprema za vertikalni transport. Pouzdanost i sigurnost na prvom mestu.',
      products: 'Proizvodi',
      company: 'Kompanija',
      about: 'O nama',
      contact: 'Kontakt',
      legal: 'Pravna napomena',
      rights: 'Sva prava zadržana.'
    },
    inquiry: {
      title: 'Zatražite ponudu',
      name: 'Ime i prezime',
      namePlaceholder: 'Vaše ime',
      company: 'Kompanija',
      companyPlaceholder: 'Naziv kompanije (opciono)',
      email: 'Email adresa',
      emailPlaceholder: 'vas@email.com',
      phone: 'Broj telefona',
      phonePlaceholder: '+381 ...',
      product: 'Proizvod',
      selectProduct: 'Izaberite proizvod',
      message: 'Poruka',
      messagePlaceholder: 'Opišite vaše potrebe...',
      submit: 'Pošaljite upit',
      submitting: 'Slanje...',
      successTitle: 'Upit je poslat!',
      successText: 'Kontaktiraćemo vas u najkraćem roku.',
      errorText: 'Greška pri slanju. Pokušajte ponovo.'
    },
    pages: {
      productsTitle: 'Naši modeli',
      productsSubtitle: 'Kompletna linija SCA, SCB i SCC konfiguracija.',
      viewAll: 'Svi modeli',
      aboutTitle: 'O',
      aboutHighlight: 'nama',
      contactTitle: 'Kontaktirajte',
      contactHighlight: 'nas',
      applicationsTitle: 'Primene',
      applicationsHighlight: ''
    }
  },
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      applications: 'Applications',
      servis: 'Service',
      gallery: 'Gallery',
      faq: 'FAQ',
      about: 'About',
      contact: 'Contact',
      requestQuote: 'Request a Quote'
    },
    hero: {
      title: 'Electric systems for',
      titleHighlight: 'cargo transport',
      btnProducts: 'View products',
      btnQuote: 'Send inquiry',
      capacity: 'Capacity',
      battery: 'Battery',
      runtime: 'Runtime',
      delivery: 'Availability',
      deliveryValue: 'On request',
      runtimeValue: 'Up to 4 hours'
    },
    what: {
      title: 'What is',
      titleHighlight: 'D-TECH SCA?',
      card1Title: 'Electric machine',
      card1Text: 'For controlled stair climbing with cargo, no physical strain, no extra workforce needed.',
      card2Title: 'Up to 250 kg capacity',
      card2Text: 'Stable operation on inclines, precise control and safety at every step.',
      card3Title: 'Professional solution',
      card3Text: 'Designed for construction, logistics, delivery and all buildings without elevators.',
      footer: 'D-TECH SCA is a compact electric stair climbing system for cargo transport. Built for daily use in real conditions, reliable, stable and easy to operate.'
    },
    showcase: {
      title: '',
      titleHighlight: 'Configurations',
      subtitle: '',
      requestQuote: 'Request a quote',
      price: 'excl. VAT.',
      leadTime: '2 month lead time.',
      safetyTitle: 'Safety first',
      safetyText: 'Electric brake for stable operation',
      capacity: 'Capacity',
      motor: 'Motor',
      battery: 'Battery',
      weight: 'Weight',
      batteryNote: '* Battery runtime up to 4h per set under load in optimal conditions. Additional battery: €250 excl. VAT.'
    },
    coreValues: {
      title: 'Why',
      titleHighlight: 'D-TECH?',
      subtitle: 'Every detail is designed for professional use.'
    },
    whyDtech: {
      title: 'Advantages of',
      titleHighlight: 'D-TECH system'
    },
    applications: {
      title: 'Where is it',
      titleHighlight: 'used?',
      subtitle: 'D-TECH equipment is used across various industries and situations.'
    },
    demo: {
      title: 'Request a',
      titleHighlight: 'demonstration',
      subtitle: 'See the machine in action. We organize demonstrations at your location.',
      btn: 'Request demonstration'
    },
    contact: {
      title: 'Contact',
      titleHighlight: 'us',
      subtitle: 'Available for all questions and inquiries.'
    },
    popup: {
      badge: 'SUMMER SALE 2026',
      title: 'Promotional prices on all models',
      titleLine2: '',
      body: 'Prices of all D-TECH models have been reduced by up to €200.',
      date: 'August 15, 2026',
      bonus: '',
      avans: 'Offer valid until August 15, 2026.',
      limited: '',
      btnPrimary: 'View models',
      btnSecondary: ''
    },
    footer: {
      description: 'Professional electric equipment for vertical transport. Reliability and safety first.',
      products: 'Products',
      company: 'Company',
      about: 'About',
      contact: 'Contact',
      legal: 'Legal notice',
      rights: 'All rights reserved.'
    },
    inquiry: {
      title: 'Request a quote',
      name: 'Full name',
      namePlaceholder: 'Your name',
      company: 'Company',
      companyPlaceholder: 'Company name (optional)',
      email: 'Email address',
      emailPlaceholder: 'you@email.com',
      phone: 'Phone number',
      phonePlaceholder: '+1 ...',
      product: 'Product',
      selectProduct: 'Select a product',
      message: 'Message',
      messagePlaceholder: 'Describe your needs...',
      submit: 'Send inquiry',
      submitting: 'Sending...',
      successTitle: 'Inquiry sent!',
      successText: 'We will contact you as soon as possible.',
      errorText: 'Error sending. Please try again.'
    },
    pages: {
      productsTitle: 'Our Models',
      productsSubtitle: 'Complete SCA, SCB and SCC configuration lineup.',
      viewAll: 'All Models',
      aboutTitle: 'About',
      aboutHighlight: 'us',
      contactTitle: 'Contact',
      contactHighlight: 'us',
      applicationsTitle: 'Applications',
      applicationsHighlight: ''
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      products: 'Продукция',
      applications: 'Применение',
      servis: 'Сервис',
      gallery: 'Галерея',
      faq: 'Вопросы',
      about: 'О нас',
      contact: 'Контакты',
      requestQuote: 'Запросить цену'
    },
    hero: {
      title: 'Электрические системы для',
      titleHighlight: 'транспортировки грузов',
      btnProducts: 'Посмотреть продукцию',
      btnQuote: 'Отправить запрос',
      capacity: 'Грузоподъёмность',
      battery: 'Аккумулятор',
      runtime: 'Работа',
      delivery: 'Наличие',
      deliveryValue: 'По запросу',
      runtimeValue: 'До 4 часов'
    },
    what: {
      title: 'Что такое',
      titleHighlight: 'D-TECH SCA?',
      card1Title: 'Электрическая машина',
      card1Text: 'Для контролируемой транспортировки грузов по лестницам без физических усилий и дополнительного персонала.',
      card2Title: 'Грузоподъёмность до 250 кг',
      card2Text: 'Стабильная работа на наклоне, точное управление и безопасность на каждом шаге.',
      card3Title: 'Профессиональное решение',
      card3Text: 'Предназначено для строительства, логистики, доставки и всех зданий без лифта.',
      footer: 'D-TECH SCA — это компактная электрическая система для транспортировки грузов по лестницам. Создана для ежедневной работы в реальных условиях: надёжная, стабильная и простая в управлении.'
    },
    showcase: {
      title: '',
      titleHighlight: 'Конфигурации',
      subtitle: '',
      requestQuote: 'Запросить цену',
      price: 'без НДС.',
      leadTime: 'Срок поставки — 2 месяца.',
      safetyTitle: 'Безопасность прежде всего',
      safetyText: 'Электрический тормоз для стабильной работы',
      capacity: 'Грузоподъёмность',
      motor: 'Мотор',
      battery: 'Аккумулятор',
      weight: 'Вес',
      batteryNote: '* Время работы аккумулятора до 4 ч на комплект под нагрузкой в оптимальных условиях. Дополнительный аккумулятор: €250 без НДС.'
    },
    coreValues: {
      title: 'Почему',
      titleHighlight: 'D-TECH?',
      subtitle: 'Каждая деталь продумана для профессионального использования.'
    },
    whyDtech: {
      title: 'Преимущества',
      titleHighlight: 'системы D-TECH'
    },
    applications: {
      title: 'Где',
      titleHighlight: 'используется?',
      subtitle: 'Оборудование D-TECH применяется в различных отраслях и ситуациях.'
    },
    demo: {
      title: 'Запросите',
      titleHighlight: 'демонстрацию',
      subtitle: 'Посмотрите машину в действии. Организуем демонстрацию на вашей территории.',
      btn: 'Запросить демонстрацию'
    },
    contact: {
      title: 'Свяжитесь с',
      titleHighlight: 'нами',
      subtitle: 'Мы доступны для всех вопросов и запросов.'
    },
    popup: {
      badge: 'ЛЕТНЯЯ АКЦИЯ 2026',
      title: 'Акционные цены на все модели',
      titleLine2: '',
      body: 'Цены на все модели D-TECH снижены до 200 €.',
      date: '15 августа 2026 г.',
      bonus: '',
      avans: 'Предложение действительно до 15 августа 2026 года.',
      limited: '',
      btnPrimary: 'Смотреть модели',
      btnSecondary: ''
    },
    footer: {
      description: 'Профессиональное электрическое оборудование для вертикального транспорта. Надёжность и безопасность на первом месте.',
      products: 'Продукция',
      company: 'Компания',
      about: 'О нас',
      contact: 'Контакты',
      legal: 'Правовая информация',
      rights: 'Все права защищены.'
    },
    inquiry: {
      title: 'Запросить цену',
      name: 'Имя и фамилия',
      namePlaceholder: 'Ваше имя',
      company: 'Компания',
      companyPlaceholder: 'Название компании (необязательно)',
      email: 'Электронная почта',
      emailPlaceholder: 'vas@email.com',
      phone: 'Номер телефона',
      phonePlaceholder: '+7 ...',
      product: 'Продукт',
      selectProduct: 'Выберите продукт',
      message: 'Сообщение',
      messagePlaceholder: 'Опишите ваши потребности...',
      submit: 'Отправить запрос',
      submitting: 'Отправка...',
      successTitle: 'Запрос отправлен!',
      successText: 'Мы свяжемся с вами в ближайшее время.',
      errorText: 'Ошибка отправки. Попробуйте ещё раз.'
    },
    pages: {
      productsTitle: 'Наши модели',
      productsSubtitle: 'Полная линейка конфигураций SCA, SCB и SCC.',
      viewAll: 'Все модели',
      aboutTitle: 'О',
      aboutHighlight: 'нас',
      contactTitle: 'Свяжитесь с',
      contactHighlight: 'нами',
      applicationsTitle: 'Применение',
      applicationsHighlight: ''
    }
  }
};
type Translations = typeof translations.sr;
interface LanguageContextType {
  lang: Language;
  setLang: (l: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'sr',
  setLang: () => {},
  t: translations.sr
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('sr');
  useEffect(() => {
    setLangState(detectLanguage());
  }, []);
  const setLang = (l: Language) => {
    localStorage.setItem('dtech-lang', l);
    setLangState(l);
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-649" data-mp="29xrvjv0k2sak">
      {children}
    </LanguageContext.Provider>;
}
export function useTranslation() {
  return useContext(LanguageContext);
}